import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

// import { AmazonKeywordGeneratorResultsPage } from "./amazon-keyword-generator/AmazonKeywordGeneratorResultsPage";
import { KeywordGeneratorToolInlinePage } from "./google-keyword-generator/KeywordGeneratorToolInlinePage";
import type { EngineName } from "./KeywordGeneratorModuleFrame";
import { YoutubeKeywordGeneratorResultsPage } from "./youtube-keyword-generator/YoutubeKeywordGeneratorResultsPage";

export const KeywordGeneratorToolBasePage: FC = () => {
    const { params } = useCurrentStateAndParams();
    const searchEngine: EngineName = params.searchEngine;

    switch (searchEngine) {
        case "google":
            return <KeywordGeneratorToolInlinePage />;
        case "youtube":
            return <YoutubeKeywordGeneratorResultsPage />;
        default:
            throw new Error(`Invalid search engine: ${searchEngine}`);
    }
};
